import { render, staticRenderFns } from "./RemainderOfEstateDistribution.vue?vue&type=template&id=6f54c04e&scoped=true"
import script from "./RemainderOfEstateDistribution.vue?vue&type=script&lang=js"
export * from "./RemainderOfEstateDistribution.vue?vue&type=script&lang=js"
import style0 from "./RemainderOfEstateDistribution.vue?vue&type=style&index=0&id=6f54c04e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f54c04e",
  null
  
)

export default component.exports